<div class="field-block" [class.invalid]="isInvalid">
  <label class="field-label">
    {{ field.label }}
    <span class="required" *ngIf="field.mandatory">*</span>
    <span class="tooltip-icon" *ngIf="field.tooltip" [title]="field.tooltip">&#9432;</span>
  </label>

  <ng-container [ngSwitch]="field.type">
    <input
      *ngSwitchCase="'text'"
      class="form-control"
      type="text"
      [(ngModel)]="field.defaultValue"
      [disabled]="readonly"
    />

    <textarea
      *ngSwitchCase="'textarea'"
      class="form-control"
      rows="3"
      [(ngModel)]="field.defaultValue"
      [disabled]="readonly"
    ></textarea>

    <input
      *ngSwitchCase="'numeric'"
      class="form-control"
      type="text"
      inputmode="numeric"
      [(ngModel)]="field.defaultValue"
      [disabled]="readonly"
    />

    <input
      *ngSwitchCase="'date'"
      class="form-control"
      type="date"
      [(ngModel)]="field.defaultValue"
      [disabled]="readonly"
    />

    <select *ngSwitchCase="'select'" class="form-control" [(ngModel)]="field.defaultValue" [disabled]="readonly">
      <option [ngValue]="null" disabled>Select&hellip;</option>
      <option *ngFor="let opt of field.options" [value]="opt">{{ opt }}</option>
    </select>

    <div *ngSwitchCase="'radio'" class="choice-group">
      <label class="choice-item" *ngFor="let opt of field.options; let i = index">
        <input type="radio" [name]="field.label + '_' + i" [value]="opt" [(ngModel)]="field.defaultValue" [disabled]="readonly" />
        {{ opt }}
      </label>
    </div>

    <div *ngSwitchCase="'multiselect'" class="choice-group">
      <label class="choice-item" *ngFor="let opt of field.options">
        <input type="checkbox" [checked]="isChecked(opt)" (change)="toggleMultiValue(opt)" [disabled]="readonly" />
        {{ opt }}
      </label>
    </div>

    <div *ngSwitchCase="'checkbox'" class="choice-group">
      <label class="choice-item" *ngFor="let opt of field.options">
        <input type="checkbox" [checked]="isChecked(opt)" (change)="toggleMultiValue(opt)" [disabled]="readonly" />
        {{ opt }}
      </label>
    </div>

    <div *ngSwitchCase="'composite'" class="composite-group">
      <app-field-renderer
        *ngFor="let child of field.childFields"
        [field]="child"
        [readonly]="readonly"
        [showValidation]="showValidation"
      ></app-field-renderer>
    </div>
  </ng-container>

  <input
    *ngIf="hasOtherSelected"
    class="form-control other-input"
    type="text"
    placeholder="Please specify"
    [(ngModel)]="field.otherValue"
    [disabled]="readonly"
  />

  <span class="form-error" *ngIf="isInvalid">This field is required</span>

  <div class="conditional-block" *ngFor="let group of activeConditionalGroups">
    <app-field-renderer
      *ngFor="let condField of group"
      [field]="condField"
      [readonly]="readonly"
      [showValidation]="showValidation"
    ></app-field-renderer>
  </div>
</div>
